import { FilterDropdownType } from 'components/more-filters/MoreFilters';
import { FilterIds } from 'constants/filterConstants';
import { JobStatus, NO_INVOICE_FILTER_ID } from 'containers/jobs/constant';

export enum ViewType {
  MEMBER = 'member',
  STATUS = 'status'
}

export const MapFilterIds = FilterIds;

export const MAP_FILTER_OPTIONS = [
  {
    id: MapFilterIds.CUSTOMER,
    label: 'Customer',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'ID',
    nameKey: 'name',
    secondaryDataKey: 'lastName'
  },
  {
    id: MapFilterIds.SERVICE_AREA,
    label: 'Service area',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'id',
    nameKey: 'name'
  },
  {
    id: MapFilterIds.EXTERNAL_COMPANY,
    label: 'External company',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'id',
    nameKey: 'companyName'
  },
  {
    id: MapFilterIds.LEAD_SOURCE,
    label: 'Lead source',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label'
  },
  {
    id: MapFilterIds.AMOUNT,
    label: 'Amount',
    type: FilterDropdownType.AMOUNT
  },
  {
    id: MapFilterIds.CREATED_BY,
    label: 'Created by',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'merchantId',
    nameKey: 'firstName'
  },
  {
    id: MapFilterIds.INVOICE_STATUS,
    label: 'Invoice status',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label',
    showSearchInFilter: false,
    hasNoOption: true
  },
  {
    id: MapFilterIds.ESTIMATE_STATUS,
    label: 'Estimate status',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'value',
    nameKey: 'label',
    showSearchInFilter: false,
    hasNoOption: true
  },
  {
    id: MapFilterIds.TAGS,
    label: 'Tags',
    type: FilterDropdownType.DROPDOWN,
    hasNoOption: true
  },
  {
    id: MapFilterIds.CREATED_ON,
    label: 'Created on',
    type: FilterDropdownType.DATE
  }
];

export enum InvoiceStatusFilter {
  PENDING = 'PENDING',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  OVERDUE = 'OVERDUE'
}

export enum InvoiceStatusFilterTitles {
  PENDING = 'Pending',
  PARTIALLY_PAID = 'Partially paid',
  PARTIALLY_REFUNDED = 'Partially refunded',
  PAID = 'Paid',
  REFUNDED = 'Refunded',
  OVERDUE = 'Overdue'
}

export const InvoiceStatuses = Object.keys(InvoiceStatusFilter).map(key => ({
  value: InvoiceStatusFilter[key as keyof typeof InvoiceStatusFilter],
  label: InvoiceStatusFilterTitles[key as keyof typeof InvoiceStatusFilterTitles]
}));

export const InvoiceStatusesForFilter = [{ value: NO_INVOICE_FILTER_ID, label: 'No invoice' }, ...InvoiceStatuses];

export const FINISHED_JOB_STATUSES = [
  JobStatus.DONE,
  JobStatus.CANCELED,
  JobStatus.ARCHIVED,
  JobStatus.DONE_PENDING_APPROVAL
];

export const DONE_JOB_STATUSES = [JobStatus.DONE, JobStatus.DONE_PENDING_APPROVAL];

export enum SchedulePreset {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  NEXT_7_DAYS = 'NEXT_7_DAYS',
  NEXT_14_DAYS = 'NEXT_14_DAYS',
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR'
}

export const SchedulePresetLabels = {
  [SchedulePreset.TODAY]: 'Today',
  [SchedulePreset.TOMORROW]: 'Tomorrow',
  [SchedulePreset.NEXT_7_DAYS]: 'Next 7 days',
  [SchedulePreset.NEXT_14_DAYS]: 'Next 14 days',
  [SchedulePreset.THIS_WEEK]: 'This week',
  [SchedulePreset.LAST_WEEK]: 'Last week',
  [SchedulePreset.THIS_MONTH]: 'This month',
  [SchedulePreset.LAST_MONTH]: 'Last month',
  [SchedulePreset.THIS_YEAR]: 'This year',
  [SchedulePreset.LAST_YEAR]: 'Last year'
};
